/**
 * 抄表结算-模板与电站的映射常量。
 *
 * 说明:目前后端尚未提供"电站可用模板列表"接口,模板卡片的显隐仍需按电站号硬编码判断。
 * 这里把散落在 Statement.vue 里的魔法数字集中管理,便于新增/维护电站时统一修改。
 * 待后端提供接口后,应改为由 templateId / 模板列表驱动,并移除本文件。
 */

/** 津西专用模板对应的电站 id */
export const JINGXI_STATION_ID = 656;

/** 海四达模板对应的电站 id 列表 */
export const HAISIDA_STATION_IDS = [703, 760, 816, 811];

/** 是否为津西电站 */
export function isJingxiStation(stationId) {
  return Number(stationId) === JINGXI_STATION_ID;
}

/** 是否为海四达电站 */
export function isHaisidaStation(stationId) {
  return HAISIDA_STATION_IDS.includes(Number(stationId));
}
